import { Deserializer } from 'jsonapi-serializer';
import * as queryString from 'query-string';
import {
  parseCompareSectorData,
  getGraphType,
  updateCountryScores,
  addServerLink,
  getAvailableYears,
  getTempCountrySectorData,
  getTempCountryInfo,
  getUniqueSectorsName
} from 'utils/countryProfile';
import {
  SECTORS,
  SEC_SECTORS,
  CATEGORIES,
  SUBCATEGORIES,
  SEC_CATEGORIES,
  SEC_SUBCATEGORIES,
  BUBBLES,
  ARC,
  TABLE,
  COUNTRY_SECTOR_YEAR_DATA,
  SEC_SPECIAL_INSTITUTIONS
} from 'constants/apiQueries';
import { setSortBy } from 'redux-modules/data';
import { getLatestYear, uniqueValuesFilter } from 'utils/general';
// Actions
const GET_COUNTRY_REPORT = 'country-profiles/GET_COUNTRY_REPORT';
const GET_COUNTRY_REPORT_MULTI_YEAR_DATA = 'country-profiles/GET_COUNTRY_REPORT_MULTI_YEAR_DATA';
const GET_COUNTRY_REPORT_SPECIAL_INSTITUTIONS = 'country-profiles/GET_COUNTRY_REPORT_SPECIAL_INSTITUTIONS';
const GET_COUNTRY_DATA_REPORT = 'country-profiles/GET_COUNTRY_DATA_REPORT';
const GET_COMPARE_DATA = 'country-profiles/GET_COMPARE_DATA';
const GET_COUNTRY_INFO = 'country-profiles/GET_COUNTRY_INFO';
const SET_COUNTRY_SECTORS = 'country-profiles/SET_COUNTRY_SECTORS';
const SET_FILTERS = 'country-profiles/SET_FILTERS';
const GET_GRAPH_TYPE_DATA = 'country-profiles/GET_GRAPH_TYPE_DATA';
const GET_COUNTRIES = 'country-profiles/GET_COUNTRIES';
const GET_MAP_COUNTRIES = 'country-profiles/GET_MAP_COUNTRIES';
const GET_MAP_COUNTRIES_LOADING = 'country-profiles/GET_MAP_COUNTRIES_LOADING';
const GET_COUNTRIES_LOADING = 'country-profiles/GET_COUNTRIES_LOADING';
const SET_COUNTRY = 'country-profiles/SET_COUNTRY';

const GET_COMPOSITES_AVERAGE = 'country-profiles/GET_COMPOSITES_AVERAGE';
const GET_CATEGORIES_AVERAGE = 'country-profiles/GET_CATEGORIES_AVERAGE';
const GET_SUBCATEGORIES_AVERAGE = 'country-profiles/GET_SUBCATEGORIES_AVERAGE';
const GET_INDICATORS_AVERAGE = 'country-profiles/GET_INDICATORS_AVERAGE';
const cache = {};
// Reducer
const initialState = {
  filters: {
    sector: '',
    years: []
  },
  country: '',
  countries: [],
  countriesLoading: false,
  mapCountries: [],
  mapCountriesLoading: false,
  data: {},
  dataReport: {},
  info: {},
  sectors: [],
  years: [],
  graphTypeData: null,
  compareData: {
    otherSector: {},
    compareDataLoading: true
  },
  averages: {
    composite: {},
    categories: {},
    subcategories: {},
    indicators: {}
  }
};

// Action Creators
export default function reducer(state = initialState, action) {
  switch (action.type) {
    case GET_COUNTRY_DATA_REPORT: {
      const data = Object.assign({}, state.data, {});
      data[action.payload.iso] = action.payload.data;
      return Object.assign({}, state, { data });
    }
    case GET_COUNTRY_REPORT: {
      // const data = Object.assign({}, state.data, {});
      // data[action.payload.iso] = action.payload.∂data;
      return Object.assign({}, state, { dataReport: action.payload.data, years: action.payload.years || [] });
    }
    case GET_COUNTRY_REPORT_SPECIAL_INSTITUTIONS:
    case GET_COUNTRY_REPORT_MULTI_YEAR_DATA: {
      // const data = Object.assign({}, state.data, {});
      // data[action.payload.iso] = action.payload.data;
      return Object.assign({}, state, { dataReport: { ...state.dataReport, 'country-sector-year-data': action.payload.data } });
    }
    case GET_COUNTRY_INFO: {
      return Object.assign({}, state, {
        info: action.payload.info,
        sectors: action.payload.sectors
      });
    }
    case SET_COUNTRY_SECTORS: {
      return Object.assign({}, state, {
        sectors: action.payload.sectors
      });
    }
    case GET_COUNTRIES: {
      return Object.assign({}, state, {
        countries: action.payload,
        countriesLoading: false
      });
    }
    case GET_MAP_COUNTRIES_LOADING: {
      return Object.assign({}, state, {
        mapCountriesLoading: action.payload
      });
    }
    case GET_MAP_COUNTRIES: {
      return Object.assign({}, state, {
        mapCountries: action.payload
      });
    }
    case GET_COUNTRIES_LOADING: {
      return Object.assign({}, state, { countriesLoading: action.payload });
    }
    case GET_COMPARE_DATA: {
      return Object.assign({}, state, { compareData: action.payload });
    }
    case SET_COUNTRY: {
      return Object.assign({}, state, { country: action.payload });
    }
    case SET_FILTERS:
      return Object.assign({}, state, { filters: action.payload });
    case GET_GRAPH_TYPE_DATA:
      return Object.assign({}, state, { graphTypeData: action.payload });
    case GET_COMPOSITES_AVERAGE: {
      const newAverages = Object.assign({}, state.averages, {
        composite: action.payload
      });
      return Object.assign({}, state, { averages: newAverages });
    }
    case GET_CATEGORIES_AVERAGE: {
      const newAverages = Object.assign({}, state.averages, {
        categories: action.payload
      });
      return Object.assign({}, state, { averages: newAverages });
    }
    case GET_SUBCATEGORIES_AVERAGE: {
      const newAverages = Object.assign({}, state.averages, {
        subcategories: action.payload
      });
      return Object.assign({}, state, { averages: newAverages });
    }
    case GET_INDICATORS_AVERAGE: {
      const newAverages = Object.assign({}, state.averages, {
        indicators: action.payload
      });
      return Object.assign({}, state, { averages: newAverages });
    }
    default:
      return state;
  }
}

export function setDataFilters(filters) {
  return {
    type: SET_FILTERS,
    payload: filters
  };
}

export function setCountry(country) {
  return {
    type: SET_COUNTRY,
    payload: country
  };
}
export function setCountrySectors(countrySectors) {
  return {
    type: SET_COUNTRY_SECTORS,
    payload: countrySectors
  };
}

export function getCountries(years) {
  let defaultQueryParams = {
    include: 'country-sectors.sector,groups',
    'page[size]': 100,
    sort: 'name'
  };
  const updatedYear = years && Array.isArray(years) ? years.join(',') : null;
  const latestYear = getLatestYear(years);
  if (updatedYear) {
    defaultQueryParams = {
      ...defaultQueryParams,
      year: updatedYear
    };
  }
  const params = queryString.stringify(defaultQueryParams);
  const LOADING_TYPE = !updatedYear ? GET_MAP_COUNTRIES_LOADING : GET_COUNTRIES_LOADING;
  const url = `${config.apiHost}/countries?${params}`;
  return (dispatch) => {
    if (cache[url]) {
      dispatch({ type: GET_COUNTRIES, payload: cache[url] });
      if (!updatedYear) {
        dispatch({ type: GET_MAP_COUNTRIES, payload: cache[url] });
      }
      return;
    }

    dispatch({ type: LOADING_TYPE, payload: true });

    fetch(url)
      .then((response) => response.json())
      .then((data) => {
        new Deserializer().deserialize(data, (err, dataParsed) => {
          // console.log('countries data is', dataParsed);
          const updatedData = updateCountryScores(dataParsed);
          // console.log('updated countries data is', updatedData);
          cache[url] = updatedData;
          dispatch({ type: GET_COUNTRIES, payload: updatedData });
          if (latestYear) { dispatch(setSortBy(`score${latestYear}`, 'desc')); }
          if (!updatedYear) {
            dispatch({ type: GET_MAP_COUNTRIES, payload: updatedData });
            dispatch({ type: GET_MAP_COUNTRIES_LOADING, payload: false });
          } else dispatch({ type: GET_COUNTRIES_LOADING, payload: false });
        });
      })
      .catch(() => {
        // Fetch from server ko -> Dispatch error
        dispatch({ type: LOADING_TYPE, payload: false });
      });
  };
}

export function getCompositesAverage() {
  const url = `${config.apiHost}/composites`;
  return (dispatch) => {
    fetch(url)
      .then((response) => response.json())
      .then((data) => {
        dispatch({
          type: GET_COMPOSITES_AVERAGE,
          payload: data.data.map((c) => c.attributes)
        });
      });
  };
}

export function getCategoriesAverage() {
  const url = `${config.apiHost}/categories`;
  return (dispatch) => {
    fetch(url)
      .then((response) => response.json())
      .then((data) => {
        dispatch({
          type: GET_CATEGORIES_AVERAGE,
          payload: data.data.map((c) => c.attributes)
        });
      });
  };
}

export function getSubcategoriesAverage() {
  const url = `${config.apiHost}/subcategories`;
  return (dispatch) => {
    fetch(url)
      .then((response) => response.json())
      .then((data) => {
        dispatch({
          type: GET_SUBCATEGORIES_AVERAGE,
          payload: data.data.map((s) => s.attributes)
        });
      });
  };
}

export function getIndicatorsAverage() {
  const url = `${config.apiHost}/indicators`;
  return (dispatch) => {
    fetch(url)
      .then((response) => response.json())
      .then((data) => {
        dispatch({
          type: GET_INDICATORS_AVERAGE,
          payload: data.data.map((i) => i.attributes)
        });
      });
  };
}

export function getGraphTypeData(type, years) {
  let url = '';
  const graphType = getGraphType(type);
  return (dispatch) => {
    switch (graphType) {
      case 'bubbles':
        url = `${config.apiHost}/${BUBBLES}${years ? `&year=${years}` : ''}`;
        break;
      case 'arc':
        url = `${config.apiHost}/${ARC}${years ? `&year=${years}` : ''}`;
        break;
      case 'table':
        url = `${config.apiHost}/${TABLE}${years ? `&year=${years}` : ''}`;
        break;
      default:
        url = '';
    }
    if (url.length && cache[url]) {
      dispatch({
        type: GET_GRAPH_TYPE_DATA,
        payload: cache[url]
      });
      return;
    }
    if (url.length) {
      fetch(url)
        .then((response) => response.json())
        .then((data) => {
          new Deserializer().deserialize(data, (err, dataParsed) => {
            cache[url] = dataParsed;
            dispatch({
              type: GET_GRAPH_TYPE_DATA,
              payload: dataParsed
            });
          });
        });
    }
  };
}

export function getCountryInfo(iso, year) {
  const updatedYear = year && Array.isArray(year) ? year.join(',') : null;
  const url = `${
    config.apiHost
  }/countries?filter[iso]=${iso}&include=${SECTORS},${SEC_SECTORS},${COUNTRY_SECTOR_YEAR_DATA},${SEC_SPECIAL_INSTITUTIONS},documents${
    updatedYear ? `&year=${updatedYear}` : ''
  }&sort=name&page[size]=100`;

  return (dispatch, state) => {
    const mapCountries = state().countryProfile.mapCountries;
    const { info: tempInfo, sectors: tempSectors } = getTempCountryInfo(mapCountries, iso);
    if (tempInfo && tempInfo.country) {
      dispatch({
        type: GET_COUNTRY_INFO,
        payload: { info: tempInfo, sectors: tempSectors }
      });
    }
    fetch(url)
      .then((response) => response.json())
      .then((data) => {
        new Deserializer().deserialize(data, (err, dataParsed) => {
          const sectors = dataParsed[0]['country-sectors'].map(
            (sec) => (sec.sector || {}).name
          ).filter(el => !!el).filter(uniqueValuesFilter);

          const sectorsInfo = dataParsed[0]['country-sectors'].map((sec) =>
            Object.assign({}, sec, { name: (sec.sector || {}).name })
          ).map(sec => ({ ...sec, year: sec.year || '2017' }));
          const documentUri = dataParsed[0]['document-url'];
          const documents = (dataParsed[0].documents || []).map(el => ({ ...el, document: addServerLink(el.document) }));
          const info = {
            country: dataParsed[0].name,
            sectorsInfo,
            documents: documents || [],
            documentUri: addServerLink(documentUri)
          };
          dispatch({
            type: GET_COUNTRY_INFO,
            payload: { info, sectors }
          });
        });
      });
  };
}

function getCompareData(dispatch, sectorId, sectorName) {
  const sections = `${SEC_CATEGORIES},${SEC_SUBCATEGORIES}`;
  const includes = `${CATEGORIES}.${SUBCATEGORIES},${sections}`;
  const url = `${config.apiHost}/country-sectors/${sectorId}?include=${includes}`;

  fetch(url)
    .then((response) => response.json())
    .then((dataRaw) => {
      new Deserializer().deserialize(dataRaw, (err, dataParsed) => {
        const data = parseCompareSectorData(dataParsed, sectorName);
        dispatch({
          type: GET_COMPARE_DATA,
          payload: { otherSector: data, compareDataLoading: false }
        });
      });
    });
}

export function getCountryProfileReport(iso, year) {
  const updatedYear = year && Array.isArray(year) ? year.join(',') : null;
  const countrySectorsUrl = `${config.apiHost}/countries?filter[iso]=${iso}${
    updatedYear ? `&year=${updatedYear}` : ''
  }&include=country-sectors,country-sectors.sector,country-sectors.country-sector-year-data`;
  return (dispatch, state) => {
    dispatch({
      type: GET_COMPARE_DATA,
      payload: { otherSector: {}, compareDataLoading: true }
    });
    dispatch({
      type: GET_COUNTRY_REPORT,
      payload: { iso, data: {}, years: [] }
    });
    const mapCountries = state().countryProfile.mapCountries;
    const { tempSector, country } = getTempCountrySectorData(mapCountries, iso);
    let countryId = country.id;
    if (tempSector) {
      dispatch({
        type: GET_COUNTRY_REPORT,
        payload: { iso, data: tempSector, years: getAvailableYears(tempSector) }
      });
    }
    fetch(countrySectorsUrl)
      .then((response) => response.json())
      .then((data) => {
        new Deserializer().deserialize(data, (err, dataParsed) => {
          const currentSectorName = state().countryProfile.filters.sector;
          let sector = dataParsed[0]['country-sectors'].find(
            (s) => s.sector.name === currentSectorName
          );
          if (!countryId) countryId = dataParsed[0].id;

          if (!sector) {
            sector = dataParsed[0]['country-sectors'][0];
            dispatch(setDataFilters({ sector: sector.sector.name, years: year }));
          }
          // Get graph type data
          let currentYear = updatedYear;
          if (year && Array.isArray(year)) {
            currentYear = year[0];
          }
          const countrySectorYearData = sector && sector['country-sector-year-data']
            && sector['country-sector-year-data']
              .find(el => parseFloat(el.year) === parseFloat(currentYear)) || {};
          dispatch(getGraphTypeData(countrySectorYearData['graph-type']));

          // Get compare data if dual sector
          if (getUniqueSectorsName(dataParsed[0]['country-sectors']).length === 2) {
            const otherSector = dataParsed[0]['country-sectors'].find(
              (s) => (s.sector || {}).name && (s.sector || {}).name !== sector.sector.name
            );

            getCompareData(dispatch, otherSector.id, otherSector.sector.name);
          }

          const sections = `${SEC_CATEGORIES},${SEC_SUBCATEGORIES}`;
          const includes = `${CATEGORIES}.${SUBCATEGORIES},${sections},${COUNTRY_SECTOR_YEAR_DATA},${SEC_SPECIAL_INSTITUTIONS}`;
          const sectorDataUrl = `${config.apiHost}/country-sectors/${sector.id}?include=${includes}`;

          fetch(sectorDataUrl)
            .then((response) => response.json())
            .then((sectorData) => {
              new Deserializer().deserialize(
                sectorData,
                (error, sectorDataParsed) => {
                  dispatch({
                    type: GET_COUNTRY_REPORT,
                    payload: { iso, data: sectorDataParsed, years: getAvailableYears(sectorDataParsed) }
                  });
                }
              );
            })
            .catch(() => {
              dispatch({
                type: GET_COMPARE_DATA,
                payload: { otherSector: {}, compareDataLoading: false }
              });
            });
        });
      });
  };
}



// WEBPACK FOOTER //
// ./app/redux-modules/country-profiles.js